import { apiGet, apiPost, apiPatch, apiDelete } from './httpClient'

export async function getEventos(params = {}) {
  const defaultParams = { page: 1, page_size: 20, ...params }
  return apiGet('/descricao-eventos/', { query: defaultParams })
}

export async function getEvento(id) {
  return apiGet(`/descricao-eventos/${id}/`)
}

export async function createEvento(data) {
  return apiPost('/descricao-eventos/', data)
}

export async function updateEvento(id, data) {
  return apiPatch(`/descricao-eventos/${id}/`, data)
}

export async function deleteEvento(id) {
  return apiDelete(`/descricao-eventos/${id}/`)
}

export async function toggleEventoStatus(id, isActive) {
  return apiPatch(`/descricao-eventos/${id}/`, { is_active: isActive })
}